var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "var(--gray-40)",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50002 7.36333H9.80145V4.0906H8.50002V7.36333ZM5.24643 7.36333H6.54787V4.0906H5.24643V7.36333ZM11.7536 8.2189V2.12696H2.64356V9.98151H5.24643V11.9145L6.91227 9.98151H10.0227L11.7536 8.2189ZM9.74094 11.9451H7.19403L5.49826 13.9088H3.94499V11.9451H0.691406V3.09568L1.53734 0.817871H13.055V8.78556L9.74094 11.9451Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchChat);
export default __webpack_public_path__ + "static/media/twitch-chat.518183efab15cad95127c740ca29a7d1.svg";
export { ForwardRef as ReactComponent };